import { render, staticRenderFns } from "./CompetitionForm.vue?vue&type=template&id=60fd8405&scoped=true&"
import script from "./CompetitionForm.vue?vue&type=script&lang=js&"
export * from "./CompetitionForm.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionForm.vue?vue&type=style&index=0&id=60fd8405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd8405",
  null
  
)

export default component.exports